import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {CamMachineSummaryModel} from "./camMachineSummary.model";
import {Injectable} from "@angular/core";
@Injectable({
    providedIn: 'root'
})
export class CamMachineSummaryConverter extends HttpModelConverter<CamMachineSummaryModel> {

    protected createInstance(): CamMachineSummaryModel {
        return new CamMachineSummaryModel();
    }

    protected enrichObject(result: CamMachineSummaryModel, src: CamMachineSummaryModel) {
    }



}